
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[profile]",
      function () {
        return require("private-next-pages/profile/[profile].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[profile]"])
      });
    }
  